import { CustomizationsState } from "state/tree/homePageV1/customizations/customizationsSlice";

export const selectors = {
  getBgVideo: (state: CustomizationsState) => state.bgVideo,
  getHMarketingCampaign: (state: CustomizationsState) =>
    state.hMarketingCampaign,
  getABCTestValues: (state: CustomizationsState) => state.abcTestValues,
};
